export function isHoverPointer(event: PointerEvent) {
  return (
    (event.pointerType === 'mouse' || event.pointerType === 'pen')
    && event.buttons === 0
    && window.matchMedia('(hover: hover) and (pointer: fine)').matches
  )
}
